<template>
  <nav class="col-md-auto">
    <div class="sidebar d-md-block bg-dark">
      <div class="sidebar-sticky">
        <ul class="nav flex-column">
          <router-link class="nav-item" :to="{name:'dashboard'}" tag="li">
            <base-icon name="bar-chart" stroke="rgb(255,255,255)" class="nav-link">Dashboard</base-icon>
          </router-link>
          <router-link class="nav-item" :to="{name:'registrations'}" tag="li">
            <base-icon name="users" stroke="rgb(255,255,255)" class="nav-link">Registrations</base-icon>
          </router-link>
          <router-link :to="{name:'entries'}" class="nav-item" tag="li">
            <base-icon name="grid" stroke="rgb(255,255,255)" class="nav-link">Entries</base-icon>
          </router-link>
          <router-link class="nav-item" :to="{name:'completed-entries'}" tag="li">
            <base-icon
              name="image"
              stroke="rgb(255,255,255)"
              strokeWidth="2.5"
              class="nav-link"
            >Completed</base-icon>
          </router-link>
          <li class="review-sidebar-console">
            <review-sidebar-console v-if="this.$route.params.ceid"/>
          </li>
          <router-link :to="{name:'scores'}" class="nav-item" tag="li">
            <base-icon name="award" stroke="rgb(255,255,255)" class="nav-link">Scores</base-icon>
          </router-link>

          <router-link :to="{name:'scores'}" class="nav-item" tag="li">
            <base-icon name="star" stroke="rgb(255,255,255)" class="nav-link">Finalists</base-icon>
          </router-link>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import ReviewSidebarConsole from '@/components/review/ReviewSidebarConsole.vue'
export default {
  components: { ReviewSidebarConsole }
}
</script>

<style lang="scss">
.wrapper {
  left: 0;
  position: relative;
  width: auto;
}

main {
  position: relative;
}
#menu {
  position: absolute;
  top: 0;
  right: 0px;
  cursor: pointer;
}
.sidebar {
  font-size: 1.6em;
  width: 0;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 100;
  padding: 30px 0 0;
  box-shadow: inset 50px 0 80px rgba(0, 0, 0, 0.25);
  .nav-item {
    font-weight: 100;
    color: white;
    position: relative;
    padding-left: 0.5rem;
    opacity: 0.5;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 0.9rem;
    .icon {
      stroke: rgb(255, 255, 255) !important;
    }
  }
  li:first-child {
    margin-bottom: 1.5rem;
  }
  li.nav-item.router-link-exact-active + li.review-sidebar-console {
    display: none;
  }
  li.nav-item.router-link-active {
    font-weight: 600;
    opacity: 1;

    padding-top: 1rem;
    padding-bottom: 1rem;

    :after {
      left: 0%;
      top: 50%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-left-color: white;
      border-width: 10px;
      margin-top: -10px;
    }
  }
  li.review-sidebar-console {
    margin-bottom: 1em;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.1) 53%
    ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  }
  .dropdown-divider {
    border-top-color: rgba(255, 255, 255, 0.25);
  }
}

.sidebar-sticky {
  position: -webkit-sticky;
  position: sticky;
}
.sidebar-sticky {
  position: relative;
  top: 0;
  height: calc(100vh);
  overflow-x: hidden;
  overflow-y: auto;
}

.open.wrapper {
  left: -320px;
  position: relative;
  width: 100%;

  .sidebar {
    width: 320px;
  }
}
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  /*...*/
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .sidebar {
    width: 220px;
    display: block;
    font-size: 1em;
  }
  .wrapper {
    margin-right: 220px;
    left: 0px;
    width: auto;
  }
  #menu {
    display: none;
  }
  .open.wrapper {
    margin-right: 220px;
    left: 0px;
    width: auto;

    .sidebar {
      width: 220px;
    }
  }
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  /*...*/
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
  /*...*/
}
</style>
